import { render, staticRenderFns } from "./SolicitudesClienteView.vue?vue&type=template&id=30cb2cd0&scoped=true"
import script from "./SolicitudesClienteView.vue?vue&type=script&lang=js"
export * from "./SolicitudesClienteView.vue?vue&type=script&lang=js"
import style0 from "./SolicitudesClienteView.vue?vue&type=style&index=0&id=30cb2cd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cb2cd0",
  null
  
)

export default component.exports